import React, { useEffect,useState } from 'react';
import {  Link,useNavigate } from 'react-router-dom';
import Select from '../select';
import Input from '../input';
import Button from '../button';
import CheckBox from '../checkbox';

import MessageDialog from '../messageDialog';
import LoadingOverlay from '../loadingOverlay';
import ConfirmDialog from '../confirmDialog';
import {get, post } from '../../request'
import './styles.scss';

function ModifyAddressDialog({ initItem, onConfirm, onCancel,  isShow}) {
    const [isLoading, setIsLoading] = useState(false);
    const [formIsValid, setFormIsValid] = useState(false);
    const [isShowConfirmDialog, setConfirmDialog] = useState(false);

    const [item, setInputs] = useState(initItem);
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([]);

    var data = {};
    const [isValid, setIsValid] = useState({
        contactName: false,
        mobilePhone: false,
        provinceId: false,
        cityId: false,
        districtId: false,
        address:false
    });
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (initItem != item) {
            setInputs(initItem);
        }
        loadData();
    }, [ initItem]);

    const loadData = () => {
        setIsLoading(true);
        get('delianapi/province').then((response) => {
            setIsLoading(false);
            setProvinces(response.items);
            if (initItem.id) {
                if (initItem.province && initItem.province.id) {
                    get('delianapi/city/province/' + initItem.province.id).then((response) => {
                        setCities(response.items);
                        if (initItem.city && initItem.city.id) {
                            get('delianapi/District/city/' + initItem.city.id).then((response) => {
                                setDistricts(response.items);
                                getData();
                            });
                        }
                        else {
                            getData();
                        }
                    });
                }
                else {
                    getData();
                }
            }
            else {
                ["contactName", "mobilePhone", "address", "provinceId", "cityId", "districtId"].forEach(function (key) {
                  
                    setIsValid(oldIsValid => {
                        oldIsValid[key] = item[key] ? true : false;
                        return oldIsValid;
                    });
                });
                validateForm();
            }
        });
    }
    const getData = () => {
        setIsLoading(true);
        get('delianapi/user/address/' + initItem.id).then((response) => {
            setIsLoading(false);
            data = response.items[0];
            if (data.province && data.province.id) {
                data.provinceId = data.province.id + "";
            }
            if (data.city && data.city.id) {
                data.cityId = data.city.id + "";
            }
            if (data.district && data.district.id) {
                data.districtId = data.district.id + "";
            }
            setInputs(data);
            ["contactName", "mobilePhone", "address", "provinceId", "cityId", "districtId"].forEach(function (key) {
                if (data[key]) {
                    setIsValid(oldIsValid => {
                        oldIsValid[key] = true
                        return oldIsValid;
                    });
                }
            });
            validateForm();
        });

    }
    const validateForm = () => {
        const timer = setTimeout(() => {
            const isAllFieldsFilled = Object.values(isValid).every(value => value);
            setFormIsValid(isAllFieldsFilled);
            clearTimeout(timer);
        }, 1000);
    };
    const getCity = (provinceId, cityId, districtId)=> {
        get('delianapi/city/province/' + provinceId).then((response) => {
            var citys = response.items;
            setCities(citys);

            if (cityId) {
                getDistrict(cityId, districtId);
            }
            else {
                //如果直辖市
                if (citys.length >= 1) {
                    var theCities = citys.filter(function (city) {
                        return city.id == citys[0].value;
                    });
                    if (theCities.length > 0) {
                        getDistrict(theCities[0].id);
                    }
                    else {
                        setDistricts([]);
                    }
                }
                else {
                    setDistricts([]);
                }
            }          
           
        });
    }
    const getDistrict=(cityId, districtId)=> {
        get('delianapi/District/city/' + cityId).then((response) => {
            setDistricts( response.items);
           
        });
    }
    const handleInputChange = (name, value) => {
        setInputs({ ...item, [name]: value });
        validateForm();
    };
    const showDialog = () => {
        //setIsVisible(true);
    };

    const hideDialog = () => {
        //setIsVisible(false);
        if (onCancel) {
            onCancel(false);
        }
    };
    const navigate = useNavigate();
    const handleDeleteClick = () => {
        setConfirmDialog(true);
    }
    const confirmDeleteFinish = (data) => {
        if (data) {            
            setConfirmDialog(false);
            post('delianapi/user/mydeleteaddress/'+ item.id).then((response) => {
                setIsLoading(false);
                if (response.statusCode !== 200) {
                    setErrorMessage(response.message);
                    return;
                }
                var item = response.items[0];
                if (onConfirm) {
                    onConfirm(item);
                }
                hideDialog();

            });
        }
    }
    const handleClick = () => {
        //onConfirm();
        setSuccessMessage("");
        setErrorMessage("");
        setIsLoading(true);
       
        post('delianapi/user/savedeliveryaddress', item ).then((response)=> {
            setIsLoading(false);
            if (response.statusCode !== 200) {
                setErrorMessage( response.message);
                return;
            }
            var item = response.items[0];
            if (onConfirm) {
                onConfirm(item);
            }
            hideDialog();

        });
       
    };

    const handleCancel = () => {
        //onCancel();
        if (onCancel) {
            onCancel();
        }
        hideDialog();
    };
    const handleValidInput = (name, isNewValid) => {
        setIsValid(isValid => {
            isValid[name] = isNewValid;
            return isValid;
        });
        validateForm();
    }
    const handleSelectChange = (name, newValue) => {
        setInputs(prevFormData => ({
            ...prevFormData,
            [name]: newValue
        }));

        if (name == "provinceId") {
            var thePros = provinces.filter(function (province) {
                return province.id == newValue;

            });
            if (thePros.length > 0) {
                setInputs(prevFormData => ({
                    ...prevFormData,
                    province: thePros[0]
                }));

                getCity(newValue);               
            }
        }
        if (name == "cityId") {
            var theCities = cities.filter(function (city) {
                return city.id == newValue;
            });
            if (theCities.length > 0) {
                setInputs(prevFormData => ({
                    ...prevFormData,
                    city: theCities[0]
                }));

                getDistrict(newValue);                
            }
        }
        if (name == "districtId") {
            var theCounties = districts.filter(function (county) {
                return county.id == newValue;

            });
            if (theCounties.length > 0) {
                setInputs(prevFormData => ({
                    ...prevFormData,
                    district: theCounties[0]
                }));
            }
        }

        if (newValue) {
            setIsValid(isValid => {
                isValid[name] = true;
                return isValid;
            });
        }
        else {
            setIsValid(isValid => {
                isValid[name] = false;
                return isValid;
            });
        }
        validateForm();
    };
    return (
        <div className="dialog modifyAddress" style={{ display: isShow ? 'flex' : 'none' }}>
            <div className="dialogModel">
                <div className="closeDialog" onClick={() => handleCancel()}></div>
                    
                    <div className="dialogTitle">编辑地址信息</div>
                <div className="dialog-content">
                    <div className="dialog-in">收件人信息</div>
                        
                    <Input className="input" placeholder="收货人" value={item.contactName || ""}
                        name="contactName" onChange={value => handleInputChange('contactName', value)}
                        checkRequied={true} onValidInput={handleValidInput} />

                    <Input className="input" placeholder="联系电话"
                        value={item.mobilePhone || ""}
                        name="mobilePhone" onChange={value => handleInputChange('mobilePhone', value)}
                        checkRequied={true} onValidInput={handleValidInput} />

                    <div className="dialog-in">地址信息</div>
                    <Select className="" placeholder="选择所属省/直辖市" name="provinceId"
                        options={provinces} initialValue={item.provinceId || ""}
                        onChange={handleSelectChange} checkRequied={true} />
                    <Select className="" placeholder="选择所属市" name="cityId"
                        options={cities} initialValue={item.cityId || ""}
                        onChange={handleSelectChange} checkRequied={true} />
                    <Select className="" placeholder="选择所属区县" name="districtId"
                        options={districts} initialValue={item.districtId || ""}
                        onChange={handleSelectChange} checkRequied={true} />

                    <Input className="input" placeholder="邮政编码" value={item.zipCode || ""}
                        name="zipCode" onChange={value => handleInputChange('zipCode', value)}
                       />

                    <Input inputType="text" className="input input100" placeholder="详细地址"
                        value={item.address || ""} checkRequied={true}
                        name="address" onChange={value => handleInputChange('address', value)}
                        onValidInput={handleValidInput} />
                    <CheckBox title="设为默认地址" name="isDefault" value={item.isDefault}
                        onChange={value => handleInputChange('isDefault', value)} />
                   
                    <div className="btn-div">
                        {
                            item.id && <Button btnclass="login_btn red_btn" onClick={() => handleDeleteClick()}
                                title="删&nbsp;&nbsp;除" />
                        }                        
                        <Button btnclass={`login_btn ${formIsValid ? '' :'disabled' }`}  onClick={() => handleClick()}
                            title="保&nbsp;&nbsp;存" disabled={!formIsValid} />
                    </div>
                                          
                    </div>
            </div>

            <MessageDialog message={successMessage || errorMessage} onCancel={() => {setSuccessMessage("");
                setErrorMessage("");
            }} />
            <LoadingOverlay isLoading={isLoading} />
            <ConfirmDialog isShowConfirmDialog={isShowConfirmDialog}
                message="确定要删除吗？"
                data={item}
                onConfirm={confirmDeleteFinish}
                onCancel={() => { setConfirmDialog(false) }}
            />
        </div>
    );
};

export default ModifyAddressDialog;